import { HasOnComplete, HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    AddWishListLinesApiParameter,
    WishListLineCollectionModel,
    undoWishListLine,
} from "@NA/Services/ADIUndoWishList";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<
    AddWishListLinesApiParameter & HasOnSuccess & HasOnComplete,
    WishListLineCollectionModel
>;

export const setUndoWishListLine: HandlerType = async (props: any) => {
    props.apiResult = await undoWishListLine({
        wishListId: props.parameter.wishListId,
        wishListLines: props.parameter.wishListLines,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [setUndoWishListLine, ExecuteOnSuccessCallback];

const undoWishListLineHandler = createHandlerChainRunner(chain, "undoWishListLine");
export default undoWishListLineHandler;
